import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotesComponent } from '../life-style/notes/notes.component';
import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import { CommonModule, formatDate } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MemberService } from '../../member-details/member-service/MemberService ';
import { MemberDashboardService } from '../member-dashboard.service';
import { ActivityDataList, ActivityWorkooutDataList } from '../../models/activityData';
import moment from 'moment';

@Component({
  selector: 'app-activity',
  standalone: true,
  imports: [NotesComponent, HighchartsChartModule, FormsModule, CommonModule, MatFormFieldModule, MatDatepickerModule, MatProgressSpinnerModule],
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.css'
})

export class ActivityComponent {
  @Input() activity: any = null;
  @Input() sDate: any;
  @Input() eDate: any;
  @ViewChild('chart1') chart1: any;
  @ViewChild('chart2') chart2: any;
  @ViewChild('chart3') chart3: any;

  // Activity Graph properties
  memberId: string = '';
  Highcharts: typeof Highcharts = Highcharts;
  coptions: Highcharts.Options = {};
  chartOptions: Highcharts.Options = {};
  chartOptions1: Highcharts.Options = {};
  strainChartOptions: Highcharts.Options = {};
  endDate: string = new Date().toISOString().split('T')[0];
  startDate: string = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0];
  currentDateBmi: any;
  previousDateBmi: any;
  noRecord: boolean = false;
  stepsDates: string[] = [];
  calsDates: string[] = [];
  rawStepsDates: string[] = [];
  rawCalsDates: string[] = [];
  private chartInstance1: any;
  private chartInstance2: any;
  private chartInstance3: any;
  updateFlag: boolean = false;
  oneToOneFlag: boolean = true;
  runOutsideAngular: boolean = false;
  showChart1: boolean = true;
  showChart2: boolean = true;
  showChart3: boolean = true;
  isLoading: number = 1;
  noDataFound: boolean = false;
  noStrainDataFound: boolean = false;
  groupedActivities: { [key: string]: { calsBurned: number; mints: number; type: string; startTime?: string; endTime?: string }[] } = {};

  // Strain-specific properties
  strainScoreData: any = [];
  stepsGoals: any[] = [];
  movementCaloriesBurnGoals: any[] = [];
  // Original activity component properties
  stepsTakenPerct: any = 0;
  stepsRemainingPerct: any = 0;
  stepsStatus: any = '';
  calsStatus: any = '';
  stepsColor: any = 'white';
  calsBtnColor: any = 'white';
  totalSteps: any = '---';
  text: any = '';

  constructor(
    private memberService: MemberService,
    private dashboardService: MemberDashboardService,
    private route: ActivatedRoute
  ) {
    var d = new Date();
    var p = new Date(new Date().setDate(new Date().getDate() - 7));
    this.currentDateBmi = d
    this.previousDateBmi = p;
  }

  ngOnInit(): void {
    this.memberId = this.route.snapshot.queryParamMap.get('memberId') || '';
    this.isLoading = 1;

    // Initialize pie chart with default values
    this.updatePieChart();

    // Use input dates from parent if provided, otherwise use default dates
    const startDateToUse = this.sDate || this.startDate;
    const endDateToUse = this.eDate || this.endDate;

    // Update internal date properties
    this.startDate = startDateToUse;
    this.endDate = endDateToUse;

    if (this.memberId) {
      this.getActivityMemberById(startDateToUse, endDateToUse);
      this.getActivityData(startDateToUse, endDateToUse);
      this.getStrainScoreData(startDateToUse, endDateToUse);
    }
    this.workOutActivity(startDateToUse, endDateToUse);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update the pie chart when activity data changes
    if (changes['activity']) {
      this.updatePieChart();
    }

    // React to changes in sDate or eDate inputs from parent
    if ((changes['sDate'] || changes['eDate']) && !changes['sDate']?.firstChange && !changes['eDate']?.firstChange) {
      const startDateToUse = this.sDate || this.startDate;
      const endDateToUse = this.eDate || this.endDate;

      // Update internal date properties
      this.startDate = startDateToUse;
      this.endDate = endDateToUse;

      this.isLoading = 1;
      if (this.memberId) {
        this.getActivityMemberById(startDateToUse, endDateToUse);
        this.getActivityData(startDateToUse, endDateToUse);
        this.getStrainScoreData(startDateToUse, endDateToUse);
      }
      this.workOutActivity(startDateToUse, endDateToUse);
    }
  }

  updatePieChart(): void {
    this.stepsTakenPerct = 0;
    this.stepsRemainingPerct = 0;
    this.stepsStatus = '';
    this.calsStatus = '';
    this.totalSteps = '---';
    this.stepsColor = 'white';
    this.calsBtnColor = 'white';
    if (this.activity && this.activity.stepsStatus) {
      this.stepsTakenPerct = Math.round(this.activity.totalSteps / this.activity.stepsGoal * 100);
      this.stepsRemainingPerct = 100 - this.stepsTakenPerct;
      this.stepsStatus = this.activity.stepsStatus;
      this.stepsColor = this.getColor(this.stepsStatus);
      this.calsBtnColor = this.getColor(this.activity.calsBurntStatus);
      this.totalSteps = this.activity.totalSteps;
      this.calsStatus = this.activity.calsBurntStatus;
    }
    this.text = '<div style="font-weight:400;font-family:Urbanist, sans-serif !important;">Total Steps</div><br><div style="font-weight:900;margin-top:-17px;font-family:Urbanist, sans-serif !important;">'
      + this.totalSteps + '</div><br><div style="margin-top:-15px;border-radius: 20px;padding:9px;width:170px;color:white;font-size:17px;font-weight:400; background-color:'
      + this.stepsColor + ';font-family:Urbanist, sans-serif !important;">' + this.stepsStatus + '</div>';
    this.coptions = {
      chart: {
        plotBorderWidth: 0,
        plotShadow: false
      },
      credits: {
        enabled: false
      },

      title: {
        text: this.text,
        style: {
          textAlign: 'center',
        },
        verticalAlign: 'middle',
        useHTML: true,
        y: 90
      },
      tooltip: {
        formatter: function () {
          return this.key + ' : ' + this.y + ' %';
        },
        backgroundColor: 'rgba(0,0,0, 0.6)',
        borderWidth: 1,
        shadow: true,
        style: {
          color: '#fff',
          fontSize: '10pt',
          fontFamily: 'Urbanist, sans-serif'
        }
      },


      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
            distance: -50,
            style: {
              fontWeight: 'bold',
              color: 'white',
            }
          },
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '75%'],
          colors: ['#007AFF', '#F9F9F9'],
          size: '100%'
        }
      },
      series: [{
        type: 'pie',
        name: '',
        innerSize: '70%',
        data: [
          ['Steps Taken', this.stepsTakenPerct],
          ['Steps Remaining', this.stepsRemainingPerct]
        ]
      }]
    };
  }
  getColor(status: any) {
    if (status == 'Excellent') {
      return '#20AA4A';
    }
    else if (status == 'Good') {
      return '#D0AF00';
    }
    else if (status == 'Needs Attention') {
      return '#FF3939';
    }
  }

  // Activity Graph methods – dates in descending order (most recent first) for Activity Trend
  getGroupedDates(): string[] {
    return Object.keys(this.groupedActivities).sort((a, b) => {
      return new Date(b).getTime() - new Date(a).getTime();
    });
  }

  filterByDateBmi(startDateInput: HTMLInputElement, endDateInput: HTMLInputElement): void {
    const start = startDateInput.value;
    const end = endDateInput.value;
    if (start && end) {
      this.startDate = start;
      this.endDate = end;

      // Show loading spinner
      this.isLoading = 1;

      // Fetch new data - zoom will be reset after data loads
      this.getActivityMemberById(start, end);
      this.workOutActivity(start, end);
      this.getActivityData(start, end);
      this.getStrainScoreData(start, end);
    }
  }

  setTimePeriod(period: string) {
    const today = new Date();
    let startDate: Date;

    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }

    // Update the date picker values
    this.previousDateBmi = startDate;
    this.currentDateBmi = today;

    // Format dates for API calls
    const startDateStr = formatDate(startDate, 'Y-MM-d', 'en');
    const endDateStr = formatDate(today, 'Y-MM-d', 'en');

    // Update internal date variables
    this.startDate = startDateStr;
    this.endDate = endDateStr;

    // Show loading spinner
    this.isLoading = 1;

    // Fetch activity data for the selected period - zoom will be reset after data loads
    this.getActivityMemberById(startDateStr, endDateStr);
    this.workOutActivity(startDateStr, endDateStr);
    this.getActivityData(startDateStr, endDateStr);
    this.getStrainScoreData(startDateStr, endDateStr);
  }

  getActivityMemberById(sDate: string, eDate: string): void {
    this.noRecord = false;
    this.noDataFound = false;
    if (!this.memberId) return;
    this.memberService.getActivityMemberById(this.memberId, sDate, eDate).subscribe((data) => {
      // Extract stepsGoals and movementCaloriesBurnGoals from API response (now date-wise)
      this.stepsGoals = data.stepsGoals || [];
      this.movementCaloriesBurnGoals = data.movementCaloriesBurnGoals || [];
      
      // Filter dates to only include those within date picker range
      const datePickerStart = moment(this.startDate).startOf('day');
      const datePickerEnd = moment(this.endDate).startOf('day');
      
      // Collect all dates from step count data
      const stepDataDates = new Set<string>();
      const stepDataMap = new Map<string, any>();
      
      if (data && data.result) {
        let stepsRec = data.result.filter((item: any) => item.steps !== null);
        stepsRec.sort((a: any, b: any) => new Date(a.dayDateStr).getTime() - new Date(b.dayDateStr).getTime());
        
        stepsRec.forEach((item: any) => {
          const itemDate = moment(item.dayDateStr).startOf('day');
          if (itemDate.isSameOrAfter(datePickerStart) && itemDate.isSameOrBefore(datePickerEnd)) {
            const dateKey = itemDate.format('YYYY-MM-DD');
            stepDataDates.add(dateKey);
            stepDataMap.set(dateKey, item);
          }
        });
      }
      
      // Collect all dates from goal data (now date-wise format)
      // Only add dates where goal is NOT null (valid goal value)
      const goalDates = new Set<string>();
      if (this.stepsGoals && this.stepsGoals.length > 0) {
        this.stepsGoals.forEach((goal: any) => {
          const goalDate = (goal?.date || '').toString();
          if (!goalDate) return;
          
          // Only add date if goal value is not null
          if (goal.goal == null) return;
          
          const d = moment(goalDate).startOf('day');
          if (d.isValid() && d.isSameOrAfter(datePickerStart) && d.isSameOrBefore(datePickerEnd)) {
            goalDates.add(d.format('YYYY-MM-DD'));
          }
        });
      }
      
      // Merge dates from both sources
      const allDatesSet = new Set([...stepDataDates, ...goalDates]);
      const allDatesArray = Array.from(allDatesSet).sort((a, b) => {
        return moment(a).valueOf() - moment(b).valueOf();
      });
      
      // Check if no data found
      this.noDataFound = stepDataDates.size === 0;
      // hasGoalData is true only if there are dates with non-null goal values
      const hasGoalData = goalDates.size > 0;
      
      // Only show empty message if both step data and valid goal data are missing
      if (this.noDataFound && !hasGoalData) {
        this.createEmptyCharts();
        this.isLoading = 2;
        return;
      }
      
      // Build dates arrays and step data arrays aligned with merged dates
      this.rawStepsDates = allDatesArray;
      this.stepsDates = allDatesArray.map((dateStr: string) => {
        return moment(dateStr).format('ddd,<br/>MMM D');
      });
      
      // Build step data arrays aligned with merged dates
      const stepSer: {
        healthKit: any[];
        ios: any[];
        android: any[];
        unknown: any[];
      } = {
        healthKit: [],
        ios: [],
        android: [],
        unknown: []
      };
      
      // Fill step data arrays, using actual data when available, null otherwise
      allDatesArray.forEach((dateStr: string) => {
        const stepData = stepDataMap.get(dateStr);
        if (stepData && stepData.steps !== null) {
          stepSer.ios.push(Math.round(stepData.steps.ios));
          // stepSer.healthKit.push(Math.round(stepData.steps.healthKit));
          stepSer.android.push(Math.round(stepData.steps.android));
          stepSer.unknown.push(Math.round(stepData.steps.unknown));
        } else {
          // No step data for this date - use null to show gap in chart
          stepSer.ios.push(null);
          // stepSer.healthKit.push(null);
          stepSer.android.push(null);
          stepSer.unknown.push(null);
        }
      });
      
      // Collect all dates from calories data
      const calsDataDates = new Set<string>();
      const calsDataMap = new Map<string, any>();
      
      if (data && data.result) {
        let calsRec = data.result.filter((item: any) => item.calsBurnt !== null);
        calsRec.sort((a: any, b: any) => new Date(a.dayDateStr).getTime() - new Date(b.dayDateStr).getTime());
        
        calsRec.forEach((item: any) => {
          const itemDate = moment(item.dayDateStr).startOf('day');
          if (itemDate.isSameOrAfter(datePickerStart) && itemDate.isSameOrBefore(datePickerEnd)) {
            const dateKey = itemDate.format('YYYY-MM-DD');
            calsDataDates.add(dateKey);
            calsDataMap.set(dateKey, item);
          }
        });
      }
      
      // Collect all dates from calories goal data (now date-wise format)
      // Only add dates where goal is NOT null (valid goal value)
      const calsGoalDates = new Set<string>();
      if (this.movementCaloriesBurnGoals && this.movementCaloriesBurnGoals.length > 0) {
        this.movementCaloriesBurnGoals.forEach((goal: any) => {
          const goalDate = (goal?.date || '').toString();
          if (!goalDate) return;
          
          // Only add date if goal value is not null
          if (goal.goal == null) return;
          
          const d = moment(goalDate).startOf('day');
          if (d.isValid() && d.isSameOrAfter(datePickerStart) && d.isSameOrBefore(datePickerEnd)) {
            calsGoalDates.add(d.format('YYYY-MM-DD'));
          }
        });
      }
      
      // Merge dates from both sources for calories
      const allCalsDatesSet = new Set([...calsDataDates, ...calsGoalDates]);
      const allCalsDatesArray = Array.from(allCalsDatesSet).sort((a, b) => {
        return moment(a).valueOf() - moment(b).valueOf();
      });
      
      // Build dates arrays and calories data arrays aligned with merged dates
      this.rawCalsDates = allCalsDatesArray;
      this.calsDates = allCalsDatesArray.map((dateStr: string) => {
        return moment(dateStr).format('ddd,<br/>MMM D');
      });
      
      // Build calories data arrays aligned with merged dates
      const calSer: {
        healthKit: any[];
        ios: any[];
        android: any[];
        unknown: any[];
      } = {
        healthKit: [],
        ios: [],
        android: [],
        unknown: []
      };
      
      // Fill calories data arrays, using actual data when available, null otherwise
      allCalsDatesArray.forEach((dateStr: string) => {
        const calsData = calsDataMap.get(dateStr);
        if (calsData && calsData.calsBurnt !== null) {
          calSer.ios.push(Math.round(calsData.calsBurnt.ios));
          // calSer.healthKit.push(Math.round(calsData.calsBurnt.healthKit));
          calSer.android.push(Math.round(calsData.calsBurnt.android));
          calSer.unknown.push(Math.round(calsData.calsBurnt.unknown));
        } else {
          // No calories data for this date - use null to show gap in chart
          calSer.ios.push(null);
          // calSer.healthKit.push(null);
          calSer.android.push(null);
          calSer.unknown.push(null);
        }
      });

      // Reset chart instances to ensure clean recreation
      this.chartInstance1 = null;
      this.chartInstance2 = null;
      this.chartInstance3 = null;

      // Force chart recreation with new data
      this.forceChartRecreation();

      // Small delay to ensure charts are recreated before rendering new data
      setTimeout(() => {
        this.createChart(stepSer, calSer);
      }, 150);
    });
  }

  workOutActivity(sDate: string, eDate: string) {
    this.memberService.getWorkoutActivityMemberById(this.memberId, sDate, eDate).subscribe((response: ActivityWorkooutDataList) => {
      if (!response.result || !Array.isArray(response.result)) {
        console.error("Invalid response format:", response);
        this.groupedActivities = {};
        return;
      }
      this.groupedActivities = response.result.reduce((acc, activity) => {
        if (!activity.date || !activity.data) return acc;
        // Use date string as-is from API (no timezone conversion) - extract YYYY-MM-DD
        const formattedDate = String(activity.date).substring(0, 10);
        activity.data.type = this.formatActivityName(activity.data.type);
        const startTime = (activity as any).startTime || (activity.data as any).startTime || undefined;
        const endTime = (activity as any).endTime || (activity.data as any).endTime || undefined;
        const dataWithTime = { ...activity.data, startTime, endTime } as { calsBurned: number; mints: number; type: string; startTime?: string; endTime?: string };
        (acc[formattedDate] = acc[formattedDate] || []).push(dataWithTime);
        return acc;
      }, {} as { [key: string]: { calsBurned: number; mints: number; type: string; startTime?: string; endTime?: string }[] });

      // Within each date: sort by time descending (most recent first)
      Object.keys(this.groupedActivities).forEach((dateKey) => {
        this.groupedActivities[dateKey].sort((a, b) => {
          const timeA = this.getActivityTimeMillis(a.startTime ?? a.endTime);
          const timeB = this.getActivityTimeMillis(b.startTime ?? b.endTime);
          return timeB - timeA;
        });
      });
    });
  }

  /** Get timestamp for activity sort; supports ISO datetime (e.g. 2025-11-27T11:30:00). */
  private getActivityTimeMillis(timeStr: string | undefined): number {
    if (!timeStr) return 0;
    const parsed = new Date(timeStr).getTime();
    return isNaN(parsed) ? 0 : parsed;
  }

  formatActivityName(name: string): string {
    return name.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  // Helper function to calculate maximum value from all data series
  private getMaxValueFromData(data: any): number {
    if (!data) return 0;

    let maxValue = 0;
    const series = ['ios', 'android', 'unknown'];

    series.forEach(seriesName => {
      if (data[seriesName] && Array.isArray(data[seriesName])) {
        const seriesMax = Math.max(...data[seriesName].filter((value: number) => !isNaN(value)));
        if (seriesMax > maxValue) {
          maxValue = seriesMax;
        }
      }
    });

    // Include goal values in max calculation (date-wise format)
    const goalValues: number[] = [];
    if (this.stepsGoals && this.stepsGoals.length > 0) {
      this.stepsGoals.forEach((goal: any) => {
        // Skip if goal is null or undefined
        if (goal.goal == null) return;
        const goalValue = Number(goal.goal);
        if (!isNaN(goalValue) && goalValue > 0) {
          goalValues.push(goalValue);
        }
      });
    }

    const allValues = maxValue > 0 ? [maxValue, ...goalValues] : goalValues;
    if (allValues.length === 0) return 0;

    const finalMax = Math.max(...allValues);
    // Add 10% padding to the maximum value for better visualization
    return Math.ceil(finalMax * 1.1);
  }

  // Helper function to calculate maximum value from calories data series (including goal values)
  private getMaxValueFromCaloriesData(data: any): number {
    if (!data) return 0;

    let maxValue = 0;
    const series = ['ios', 'android', 'unknown'];

    series.forEach(seriesName => {
      if (data[seriesName] && Array.isArray(data[seriesName])) {
        const seriesMax = Math.max(...data[seriesName].filter((value: number) => !isNaN(value) && value !== null));
        if (seriesMax > maxValue) {
          maxValue = seriesMax;
        }
      }
    });

    // Include goal values in max calculation (date-wise format)
    const goalValues: number[] = [];
    if (this.movementCaloriesBurnGoals && this.movementCaloriesBurnGoals.length > 0) {
      this.movementCaloriesBurnGoals.forEach((goal: any) => {
        // Skip if goal is null or undefined
        if (goal.goal == null) return;
        const goalValue = Number(goal.goal);
        if (!isNaN(goalValue) && goalValue > 0) {
          goalValues.push(goalValue);
        }
      });
    }

    const allValues = maxValue > 0 ? [maxValue, ...goalValues] : goalValues;
    if (allValues.length === 0) return 0;

    const finalMax = Math.max(...allValues);
    // Add 10% padding to the maximum value for better visualization
    return Math.ceil(finalMax * 1.1);
  }

  // Create goal line series from stepsGoals array (date-wise format)
  // Plot goal for each date; if goal is null, skip that point so line breaks
  private createStepsGoalLineSeries(): any[] {
    if (!this.stepsGoals || this.stepsGoals.length === 0 || !this.rawStepsDates || this.rawStepsDates.length === 0) {
      return [];
    }

    const datePickerStart = moment(this.startDate).startOf('day');
    const datePickerEnd = moment(this.endDate).startOf('day');

    // Create a map of date -> goal value from the API response
    const goalMap = new Map<string, number | null>();
    this.stepsGoals.forEach((goal: any) => {
      const goalDate = (goal?.date || '').toString();
      if (!goalDate) return;
      
      const d = moment(goalDate).startOf('day');
      if (d.isValid() && d.isSameOrAfter(datePickerStart) && d.isSameOrBefore(datePickerEnd)) {
        const dateKey = d.format('YYYY-MM-DD');
        goalMap.set(dateKey, goal.goal);
      }
    });

    // Build goal data points aligned with rawStepsDates
    // Use null for dates where goal is null (line will break)
    const goalData: any[] = [];
    
    this.rawStepsDates.forEach((dateStr: string, index: number) => {
      if (!dateStr) return;
      
      const dateKey = moment(dateStr).format('YYYY-MM-DD');
      const goalValue = goalMap.get(dateKey);
      
      // Only add point if we have a valid goal value (not null/undefined)
      if (goalValue != null && Number.isFinite(Number(goalValue))) {
        goalData.push({
          x: index,
          y: Number(goalValue),
          custom: {
            dateStr: moment(dateStr).format('ddd, MMM D, YYYY'),
            goalValue: Number(goalValue)
          },
          marker: {
            enabled: true,
            radius: 3,
            symbol: 'circle'
          }
        });
      } else if (goalMap.has(dateKey)) {
        // Goal exists but is null - add null point to break the line
        goalData.push({
          x: index,
          y: null
        });
      }
    });

    // Filter out consecutive nulls and check if we have any valid data
    const validGoalData = goalData.filter((point: any) => point.y !== null);
    if (validGoalData.length === 0) {
      return [];
    }

    return [{
      type: 'line',
      name: 'Goal',
      data: goalData as Highcharts.PointOptionsObject[],
      color: '#FFD700',
      lineWidth: 2,
      connectNulls: false, // Don't connect across null values - line will break
      marker: {
        enabled: true,
        radius: 3,
        symbol: 'circle',
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      },
      enableMouseTracking: true
    }];
  }

  // Create goal line series from movementCaloriesBurnGoals array (date-wise format)
  // Plot goal for each date; if goal is null, skip that point so line breaks
  private createCaloriesGoalLineSeries(): any[] {
    if (!this.movementCaloriesBurnGoals || this.movementCaloriesBurnGoals.length === 0 || !this.rawCalsDates || this.rawCalsDates.length === 0) {
      return [];
    }

    const datePickerStart = moment(this.startDate).startOf('day');
    const datePickerEnd = moment(this.endDate).startOf('day');

    // Create a map of date -> goal value from the API response
    const goalMap = new Map<string, number | null>();
    this.movementCaloriesBurnGoals.forEach((goal: any) => {
      const goalDate = (goal?.date || '').toString();
      if (!goalDate) return;
      
      const d = moment(goalDate).startOf('day');
      if (d.isValid() && d.isSameOrAfter(datePickerStart) && d.isSameOrBefore(datePickerEnd)) {
        const dateKey = d.format('YYYY-MM-DD');
        goalMap.set(dateKey, goal.goal);
      }
    });

    // Build goal data points aligned with rawCalsDates
    // Use null for dates where goal is null (line will break)
    const goalData: any[] = [];
    
    this.rawCalsDates.forEach((dateStr: string, index: number) => {
      if (!dateStr) return;
      
      const dateKey = moment(dateStr).format('YYYY-MM-DD');
      const goalValue = goalMap.get(dateKey);
      
      // Only add point if we have a valid goal value (not null/undefined)
      if (goalValue != null && Number.isFinite(Number(goalValue))) {
        goalData.push({
          x: index,
          y: Number(goalValue),
          custom: {
            dateStr: moment(dateStr).format('ddd, MMM D, YYYY'),
            goalValue: Number(goalValue)
          },
          marker: {
            enabled: true,
            radius: 3,
            symbol: 'circle'
          }
        });
      } else if (goalMap.has(dateKey)) {
        // Goal exists but is null - add null point to break the line
        goalData.push({
          x: index,
          y: null
        });
      }
    });

    // Filter out consecutive nulls and check if we have any valid data
    const validGoalData = goalData.filter((point: any) => point.y !== null);
    if (validGoalData.length === 0) {
      return [];
    }

    return [{
      type: 'line',
      name: 'Goal',
      data: goalData as Highcharts.PointOptionsObject[],
      color: '#FFD700',
      lineWidth: 2,
      connectNulls: false, // Don't connect across null values - line will break
      marker: {
        enabled: true,
        radius: 3,
        symbol: 'circle',
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      },
      enableMouseTracking: true
    }];
  }

  createChart(stepsData: any, calsData: any): void {
    // Calculate dynamic maximum values for y-axis
    const stepsMaxValue = this.getMaxValueFromData(stepsData);
    const calsMaxValue = this.getMaxValueFromCaloriesData(calsData);
    const hasStepsData = ['ios', 'android', 'unknown'].some(key => Array.isArray(stepsData?.[key]) && stepsData[key].some((v: number) => !isNaN(v) && v > 0));
    const hasCalsData = ['ios', 'android', 'unknown'].some(key => Array.isArray(calsData?.[key]) && calsData[key].some((v: number) => !isNaN(v) && v > 0));
    const hasStepsGoalData = this.stepsGoals && this.stepsGoals.length > 0;
    const hasCalsGoalData = this.movementCaloriesBurnGoals && this.movementCaloriesBurnGoals.length > 0;
    const rawStepsDatesRef = this.rawStepsDates;
    const rawCalsDatesRef = this.rawCalsDates;
    const totalStepPoints = this.stepsDates.length;
    const totalCalPoints = this.calsDates.length;
    const stepsIsLongRange = totalStepPoints > 15;
    const calsIsLongRange = totalCalPoints > 15;
    const stepsLabelStep = stepsIsLongRange ? Math.ceil(totalStepPoints / 12) : 1; // target ~12 labels
    const calsLabelStep = calsIsLongRange ? Math.ceil(totalCalPoints / 12) : 1;

    this.chartOptions = {
      chart: {
        backgroundColor: '#F9F9F9',
        type: 'line',
        panKey: 'shift',
        panning: {
          enabled: true,
          type: 'x'
        },
        zooming: {
          type: 'x'
        }
      },
      title: { text: 'Steps Count' },
      subtitle: {
        text: (hasStepsData || hasStepsGoalData) ? '' : 'No Record found for selected date range',
        align: 'center',
        verticalAlign: 'middle',
        style: { color: '#888', fontSize: '12px' }
      },
      xAxis: {
        type: 'datetime',
        categories: this.stepsDates,
        lineWidth: 2,
        labels: {
          useHTML: true,
          step: stepsLabelStep
        }
      },
      credits: { enabled: false },
      yAxis: {
        min: 0,
        max: stepsMaxValue > 0 ? stepsMaxValue : undefined,
        lineWidth: 2,
        gridLineWidth: (hasStepsData || hasStepsGoalData) ? 1 : 0,
        minorGridLineWidth: 0,
        labels: { enabled: (hasStepsData || hasStepsGoalData) },
        tickWidth: (hasStepsData || hasStepsGoalData) ? undefined : 0,
        tickLength: (hasStepsData || hasStepsGoalData) ? undefined : 0,
        title: {
          text: 'Steps'
        }
      },
      tooltip: {
        enabled: true,
        useHTML: true,
        formatter: function () {
          const customData = this.point.options.custom ?? {};
          
          // Special tooltip for Goal line
          if (this.series.name === 'Goal') {
            const goalValue = (customData && customData['goalValue']) ? customData['goalValue'] : this.y;
            const dateStr = customData['dateStr'] || '';
            return `<b>${dateStr}</b><br>Goal: ${goalValue} Steps`;
          }
          
          if (this.y === 0) {
            return false;
          }
          const pointIndex = this.point.index !== undefined ? this.point.index : (typeof this.x === 'number' ? this.x : 0);
          const dateStr = rawStepsDatesRef && pointIndex !== undefined && rawStepsDatesRef[pointIndex] ? moment(rawStepsDatesRef[pointIndex]).format('ddd, MMM D, YYYY') : '';
          return `<b>${dateStr}</b><br>${this.series.name} : ${this.y} Steps`;
        },
        backgroundColor: 'rgba(0,0,0, 0.6)',
        borderWidth: 1,
        shadow: true,
        style: {
          color: '#fff',
          fontSize: '10pt',
          fontFamily: 'Urbanist, sans-serif'
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        },
        series: {
          marker: {
            symbol: 'circle',
            enabled: true,
            radius: 3,
            lineWidth: 1,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
      series: [
        {
          name: 'HealthKit',
          type: 'line',
          data: [],
          visible: false,
          showInLegend: false
        },
        {
          name: 'Ios',
          type: 'line',
          data: []
        },
        {
          name: 'Android',
          type: 'line',
          data: []
        },
        {
          name: 'Unknown',
          type: 'line',
          data: []
        },
        ...this.createStepsGoalLineSeries()
      ]

    };
    if (this.chartOptions.series) {
      // (this.chartOptions.series[0] as Highcharts.SeriesColumnOptions).data = stepsData.healthKit;
      (this.chartOptions.series[1] as Highcharts.SeriesColumnOptions).data = stepsData.ios;
      (this.chartOptions.series[2] as Highcharts.SeriesColumnOptions).data = stepsData.android;
      (this.chartOptions.series[3] as Highcharts.SeriesColumnOptions).data = stepsData.unknown;
    }

    this.chartOptions1 = {
      chart: {
        backgroundColor: '#F9F9F9',
        type: 'line',
        panKey: 'shift',
        panning: {
          enabled: true,
          type: 'x'
        },
        zooming: {
          type: 'x'
        }
      },
      title: { text: 'Calories Burned' },
      subtitle: {
        text: (hasCalsData || hasCalsGoalData) ? '' : 'No Record found for selected date range',
        align: 'center',
        verticalAlign: 'middle',
        style: { color: '#888', fontSize: '12px' }
      },
      xAxis: {
        type: 'datetime',
        categories: this.calsDates,
        lineWidth: 2,
        labels: {
          useHTML: true,
          step: calsLabelStep
        }
      },
      credits: { enabled: false },
      yAxis: {
        min: 0,
        max: calsMaxValue > 0 ? calsMaxValue : undefined,
        lineWidth: 2,
        gridLineWidth: (hasCalsData || hasCalsGoalData) ? 1 : 0,
        minorGridLineWidth: 0,
        labels: { enabled: (hasCalsData || hasCalsGoalData) },
        tickWidth: (hasCalsData || hasCalsGoalData) ? undefined : 0,
        tickLength: (hasCalsData || hasCalsGoalData) ? undefined : 0,
        title: {
          text: 'Calories'
        }
      },
      tooltip: {
        enabled: true,
        useHTML: true,
        formatter: function () {
          const customData = this.point.options.custom ?? {};
          
          // Special tooltip for Goal line
          if (this.series.name === 'Goal') {
            const goalValue = (customData && customData['goalValue']) ? customData['goalValue'] : this.y;
            const dateStr = customData['dateStr'] || '';
            return `<b>${dateStr}</b><br>Goal: ${goalValue} Kcal`;
          }
          
          if (this.y === 0) {
            return false;
          }
          const pointIndex = this.point.index !== undefined ? this.point.index : (typeof this.x === 'number' ? this.x : 0);
          const dateStr = rawCalsDatesRef && pointIndex !== undefined && rawCalsDatesRef[pointIndex] ? moment(rawCalsDatesRef[pointIndex]).format('ddd, MMM D, YYYY') : '';
          return `<b>${dateStr}</b><br>${this.series.name} : ${this.y} Kcal`;
        },
        backgroundColor: 'rgba(0,0,0, 0.6)',
        borderWidth: 1,
        shadow: true,
        style: {
          color: '#fff',
          fontSize: '10pt',
          fontFamily: 'Urbanist, sans-serif'
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        },
        series: {
          marker: {
            symbol: 'circle',
            enabled: true,
            radius: 3,
            lineWidth: 1,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
      series: [
        {
          name: 'HealthKit',
          type: 'line',
          data: [],
          visible: false,
          showInLegend: false
        },
        {
          name: 'Ios',
          type: 'line',
          data: []
        },
        {
          name: 'Android',
          type: 'line',
          data: []
        },
        {
          name: 'Unknown',
          type: 'line',
          data: []
        },
        ...this.createCaloriesGoalLineSeries()
      ]
    };
    if (this.chartOptions1.series) {
      // (this.chartOptions1.series[0] as Highcharts.SeriesLineOptions).data = calsData.healthKit;
      (this.chartOptions1.series[1] as Highcharts.SeriesLineOptions).data = calsData.ios;
      (this.chartOptions1.series[2] as Highcharts.SeriesLineOptions).data = calsData.android;
      (this.chartOptions1.series[3] as Highcharts.SeriesLineOptions).data = calsData.unknown;
    }

    // Add chart callbacks to capture instances for zoom control
    this.chartOptions.chart!.events = {
      load: this.chartCallback1
    };
    this.chartOptions1.chart!.events = {
      load: this.chartCallback2
    };

    // Force chart update to ensure proper recreation
    this.updateFlag = true;

    // Hide loading spinner after charts are created
    this.isLoading = 2;
  }

  // Chart callback methods for zoom functionality
  private chartCallback1 = (chart: any) => {
    const actualChart = chart.target;
    this.chartInstance1 = actualChart;
  }

  private chartCallback2 = (chart: any) => {
    const actualChart = chart.target;
    this.chartInstance2 = actualChart;
  }

  // Reset chart zoom methods
  private resetChartZoom1(): void {
    const chart = this.getChartInstance1();
    if (chart && chart.xAxis && chart.xAxis[0] && typeof chart.xAxis[0].setExtremes === 'function') {
      chart.xAxis[0].setExtremes(null, null);
    }
  }

  private resetChartZoom2(): void {
    const chart = this.getChartInstance2();
    if (chart && chart.xAxis && chart.xAxis[0] && typeof chart.xAxis[0].setExtremes === 'function') {
      chart.xAxis[0].setExtremes(null, null);
    }
  }

  // Get chart instances
  private getChartInstance1(): any {
    if (this.chartInstance1) {
      return this.chartInstance1;
    }

    if (this.chart1 && this.chart1.chart) {
      this.chartInstance1 = this.chart1.chart;
      return this.chartInstance1;
    }

    return null;
  }

  private getChartInstance2(): any {
    if (this.chartInstance2) {
      return this.chartInstance2;
    }

    if (this.chart2 && this.chart2.chart) {
      this.chartInstance2 = this.chart2.chart;
      return this.chartInstance2;
    }

    return null;
  }

  private getChartInstance3(): any {
    if (this.chartInstance3) {
      return this.chartInstance3;
    }

    if (this.chart3 && this.chart3.chart) {
      this.chartInstance3 = this.chart3.chart;
      return this.chartInstance3;
    }

    return null;
  }

  // Force chart recreation when data changes
  private forceChartRecreation(): void {
    // Destroy existing chart instances if they exist
    if (this.chartInstance1) {
      this.chartInstance1.destroy();
      this.chartInstance1 = null;
    }
    if (this.chartInstance2) {
      this.chartInstance2.destroy();
      this.chartInstance2 = null;
    }
    if (this.chartInstance3) {
      this.chartInstance3.destroy();
      this.chartInstance3 = null;
    }

    // Hide and show charts to force recreation
    this.showChart1 = false;
    this.showChart2 = false;
    this.showChart3 = false;
    this.updateFlag = false;

    // Use longer delay to ensure complete destruction
    setTimeout(() => {
      this.showChart1 = true;
      this.showChart2 = true;
      this.showChart3 = true;
      this.updateFlag = true;
    }, 100);
  }

  // Create empty charts with proper structure and message
  createEmptyCharts(): void {
    // Reset chart instances to ensure clean recreation
    this.chartInstance1 = null;
    this.chartInstance2 = null;
    this.chartInstance3 = null;

    // Force chart recreation
    this.forceChartRecreation();

    // Small delay to ensure charts are recreated before rendering empty data
    setTimeout(() => {
      this.createEmptyChart();
    }, 150);
  }

  // Create empty chart with message in plotting area
  createEmptyChart(): void {
    this.chartOptions = {
      chart: {
        backgroundColor: '#F9F9F9',
        type: 'line'
      },
      title: { text: 'Steps Count' },
      subtitle: {
        text: 'No Record found for selected date range',
        align: 'center',
        verticalAlign: 'middle',
        style: { color: '#888', fontSize: '14px' }
      },
      xAxis: {
        type: 'datetime',
        categories: [],
        lineWidth: 2,
        labels: { enabled: true }
      },
      credits: { enabled: false },
      yAxis: {
        min: 0,
        max: 1000,
        lineWidth: 2,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        labels: { enabled: false },
        tickWidth: 0,
        tickLength: 0,
        title: {
          text: 'Steps'
        }
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: false
        }
      },
      series: [
        {
          name: 'HealthKit',
          type: 'line',
          data: [],
          showInLegend: false,
          visible: false
        },
        {
          name: 'Ios',
          type: 'line',
          data: [],
          showInLegend: true
        },
        {
          name: 'Android',
          type: 'line',
          data: [],
          showInLegend: true
        },
        {
          name: 'Unknown',
          type: 'line',
          data: [],
          showInLegend: true
        }
      ]
    };

    this.chartOptions1 = {
      chart: {
        backgroundColor: '#F9F9F9',
        type: 'line'
      },
      title: { text: 'Calories Burned' },
      subtitle: {
        text: 'No data is found for the selected date ranges',
        align: 'center',
        verticalAlign: 'middle',
        style: { color: '#888', fontSize: '14px' }
      },
      xAxis: {
        type: 'datetime',
        categories: [],
        lineWidth: 2,
        labels: { enabled: true }
      },
      credits: { enabled: false },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 2,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        labels: { enabled: false },
        tickWidth: 0,
        tickLength: 0,
        title: {
          text: 'Calories'
        }
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: false
        }
      },
      series: [
        {
          name: 'HealthKit',
          type: 'line',
          data: [],
          showInLegend: false,
          visible: false
        },
        {
          name: 'Ios',
          type: 'line',
          data: [],
          showInLegend: true
        },
        {
          name: 'Android',
          type: 'line',
          data: [],
          showInLegend: true
        },
        {
          name: 'Unknown',
          type: 'line',
          data: [],
          showInLegend: true
        }
      ]
    };
  }

  // Fetch activity data for the pie chart (Total Steps and Calories)
  getActivityData(startDate: any, endDate: any) {
    this.dashboardService.getActivity(this.memberId, startDate, endDate).subscribe(response => {
      this.activity = response;
      this.activity = this.activity.result;
      // Update the pie chart with new data
      this.updatePieChart();
    });
  }

  // Strain Score Methods
  getStrainScoreData(sDate: any, eDate: any) {
    this.dashboardService.getScoreReadings(this.memberId, sDate, eDate).subscribe((data: any) => {
      this.strainScoreData = data.result?.strainScores || [];
      this.noStrainDataFound = this.strainScoreData.length === 0;

      if (this.noStrainDataFound) {
        this.createEmptyStrainChart();
        return;
      }

      // Create the strain chart with data
      this.createStrainChart();
    });
  }

  createStrainChart() {
    const strainData = this.strainScoreData.map((item: any) => {
      const currentDate = formatDate(item.date, 'yyyy-MM-dd', 'en');
      const date = Date.parse(currentDate);
      const score = item.score;
      return {
        x: date,
        y: score
      };
    });

    // Calculate min and max for y-axis
    const scores = strainData.map((d: any) => d.y);
    const minScore = Math.min(...scores);
    const maxScore = Math.max(...scores);
    const padding = Math.max(5, (maxScore - minScore) * 0.1);
    const dataMin = Math.max(0, Math.floor((minScore - padding) / 10) * 10);
    let dataMax = Math.min(100, Math.ceil((maxScore + padding) / 10) * 10);

    // Get standardized config for ranges
    const config = this.getStrainScoreConfig();

    // Cap dataMax at the nearest configured upper range boundary
    const upperBounds: number[] = (config.ranges || []).map((r: any) => r.to).filter((b: number) => typeof b === 'number');
    if (upperBounds && upperBounds.length > 0) {
      const candidateCaps = upperBounds.filter((b) => b >= maxScore && b <= dataMax);
      if (candidateCaps.length > 0) {
        const nearestCap = Math.min(...candidateCaps);
        if (nearestCap < dataMax) {
          dataMax = nearestCap;
        }
      }
    }

    // Get relevant ranges for plot bands
    const relevantRanges = config.ranges.filter((range: any) =>
      (range.from <= dataMax && range.to >= dataMin)
    );

    // Calculate tick positions
    const rangeBoundaries: number[] = [];
    relevantRanges.forEach((range: any) => {
      if (range.from >= dataMin && range.from <= dataMax) rangeBoundaries.push(range.from);
      if (range.to >= dataMin && range.to <= dataMax) rangeBoundaries.push(range.to);
    });

    if (!rangeBoundaries.includes(dataMin)) rangeBoundaries.push(dataMin);
    if (!rangeBoundaries.includes(dataMax)) rangeBoundaries.push(dataMax);
    const tickPositions: number[] = Array.from(new Set(rangeBoundaries)).sort((a, b) => a - b);

    const totalStrainPoints = strainData.length;
    const strainIsLongRange = totalStrainPoints > 15;
    const strainLabelStep = strainIsLongRange ? Math.ceil(totalStrainPoints / 12) : 1;
    const strainCategories = strainData.map((d: any) => moment(d.x).format('ddd,<br/>MMM D'));
    const strainSeriesData = strainData.map((d: any) => d.y);
    const rawStrainDatesRef = strainData.map((d: any) => d.x);

    this.strainChartOptions = {
      chart: {
        backgroundColor: '#F9F9F9',
        type: 'line',
        panKey: 'shift',
        panning: {
          enabled: true,
          type: 'x'
        },
        zooming: {
          type: 'x'
        }
      },
      title: { text: 'Strain Index' },
      xAxis: [{
        categories: strainCategories,
        lineWidth: 2,
        labels: {
          useHTML: true,
          step: strainLabelStep
        }
      }],
      credits: {
        enabled: false
      },
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal'
      },
      yAxis: [{
        lineWidth: 1,
        min: dataMin,
        max: dataMax,
        title: {
          text: 'Index'
        },
        tickPositions: tickPositions,
        plotBands: config.ranges,
        plotLines: (() => {
          const dynamicLabels: any[] = [];

          relevantRanges.forEach((range: any) => {
            let labelPosition = range.from;

            if (range.from < dataMin) {
              labelPosition = dataMin;
            }

            if (labelPosition >= dataMin && labelPosition <= dataMax) {
              dynamicLabels.push({
                value: labelPosition,
                color: 'transparent',
                width: 0,
                label: {
                  text: range.name,
                  align: 'right',
                  verticalAlign: 'middle',
                  x: -10,
                  style: {
                    fontFamily: 'Urbanist',
                    fontWeight: 600,
                    fontStyle: 'Semi Bold',
                    fontSize: '14px',
                    color: 'black',
                    backgroundColor: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    border: '2px solid #333',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                    textShadow: 'none'
                  }
                }
              });
            }
          });

          return dynamicLabels;
        })()
      }],
      tooltip: {
        enabled: true,
        formatter: function (this: Highcharts.TooltipFormatterContextObject) {
          const pointIndex = this.point.index !== undefined ? this.point.index : (typeof this.x === 'number' ? this.x : 0);
          const dateStr = rawStrainDatesRef && rawStrainDatesRef[pointIndex] ? moment(rawStrainDatesRef[pointIndex]).format('ddd, MMM D, YYYY') : '';
          return '<b>' + dateStr + '</b><br/>Strain Score: <b>' + this.y + '</b>';
        },
        backgroundColor: 'rgba(0,0,0, 0.6)',
        borderWidth: 1,
        shadow: true,
        style: {
          color: '#fff',
          fontSize: '12pt',
          fontFamily: 'Urbanist, sans-serif'
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        },
        series: {
          enableMouseTracking: true,
          marker: {
            symbol: 'circle',
            enabled: true,
            radius: 3,
            lineWidth: 1,
          }
        },
      },
      series: [{
        name: 'Strain',
        data: strainSeriesData,
        type: 'line',
        color: '#1ABC9C',  // Teal color for Strain
        showInLegend: true,
        marker: {
          symbol: 'circle',
          enabled: true,
          radius: 3,
          lineWidth: 1,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }]
    };

    // Add chart callback to capture instance for zoom control
    this.strainChartOptions.chart!.events = {
      load: this.chartCallback3
    };
  }

  createEmptyStrainChart(): void {
    const config = this.getStrainScoreConfig();

    this.strainChartOptions = {
      chart: {
        backgroundColor: '#F9F9F9',
        type: 'line'
      },
      title: { text: 'Strain Index' },
      xAxis: [{
        type: 'datetime',
        gridLineWidth: 0,
        minorGridLineWidth: 0
      }],
      yAxis: [{
        title: { text: 'Index' },
        lineWidth: 1,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
      }],
      credits: { enabled: false },
      legend: { enabled: false },
      series: [{
        type: 'line',
        name: 'Strain',
        data: [],
        showInLegend: false,
        enableMouseTracking: true
      }]
    };
  }

  getStrainScoreConfig(): any {
    return {
      ranges: [
        { from: 0, to: 8, color: '#20AA4A0D', name: 'Excellent' },
        { from: 8, to: 14, color: '#FCD34D1A', name: 'Good' },
        { from: 14, to: 18, color: '#E580090D', name: 'Fair' },
        { from: 18, to: 100, color: '#FF39390D', name: 'Poor' }
      ],
      pointColors: {
        excellent: '#20AA4A',
        good: '#FCD34D',
        fair: '#E58009',
        poor: '#FF3939'
      }
    };
  }

  private chartCallback3 = (chart: any) => {
    const actualChart = chart.target;
    this.chartInstance3 = actualChart;
  }

  private resetChartZoom3(): void {
    const chart = this.getChartInstance3();
    if (chart && chart.xAxis && chart.xAxis[0] && typeof chart.xAxis[0].setExtremes === 'function') {
      chart.xAxis[0].setExtremes(null, null);
    }
  }

}
